<template>
  <v-row no-gutters class="sign">
    <v-col>
      <h3 class="sign__title mb-3">Загрузите документы для проверки</h3>
      <FilesForm
        :file1="file1"
        :file2="file2"
        :disabled="disabled"
        @set-file="setFile"
        @check-sign="onClickHandler"
        class="mb-4"
      />
      <Results :resultSign="resultSign" :signInfo="signInfo" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CheckSign',
  components: {
    FilesForm: () => import('@/components/check/FilesForm'),
    Results: () => import('@/components/check/Results.vue')
  },
  data: () => ({
    file1: null,
    file2: null,
    disabled: true,
    resultSign: {},
    loading: false
  }),
  watch: {
    file1(value) {
      this.disabled = !(value && this.file2)
    },
    file2(value) {
      this.disabled = !(value && this.file1)
    }
  },
  computed: {
    signInfo() {
      return this.$store.state.verify.signInfo
    }
  },
  methods: {
    setFile(id, value) {
      if (id === '1') this.file1 = value
      else this.file2 = value
    },
    getHash() {
      return new Promise((resolve, reject) => {
        const hashName = 'GOST R 34.11-256-12'

        const h = new window.GostDigest()
        h.name = hashName
        const reader = new FileReader()
        reader.onload = async e => {
          const result = await e.target.result
          try {
            const binHash = await h.digest(result)
            const hashStr = await this.buf2hex(binHash)
            resolve(hashStr)
          } catch (e) {
            reject(e)
          }
        }

        try {
          reader.readAsArrayBuffer(this.file1)
        } catch (e) {
          reject(e)
        }
      })
    },
    buf2hex(buffer) {
      return Array.prototype.map
        .call(new Uint8Array(buffer), x => ('00' + x.toString(16).toUpperCase()).slice(-2))
        .join('')
    },
    getCertificate() {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = async e => {
          try {
            resolve(e.target.result)
          } catch (e) {
            reject(e)
          }
        }

        try {
          reader.readAsBinaryString(this.file2)
        } catch (e) {
          reject(e)
        }
      })
    },
    async onClickHandler() {
      const result = await Promise.all([this.getHash(), this.getCertificate()])
      const payload = {
        hash: result[0],
        signBase64: result[1]
      }
      const resultOk = {
        message: 'Документ и подпись соответсвуют друг другу',
        color: '#50BF34',
        icon: 'check',
        signValid: true,
        visible: true
      }
      const resultNone = {
        message: 'Документ и подпись не соответсвуют друг другу',
        color: '#FF0000',
        icon: 'warning',
        signValid: false,
        visible: false
      }

      this.loading = true
      const response = await this.$store.dispatch('VERIFY_SIGN', payload)
      this.loading = false
      this.file1 = this.file2 = null
      this.resultSign = response ? resultOk : resultNone
    }
  }
}
</script>

<style scoped lang="scss">
.sign {
  &__title {
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    color: #333333;
  }
}
</style>
